<template>
<div id="app" class="container-fluid pt-3 pb-5">
  <div id="overlay"></div>
  <b-row>
    <Navigation></Navigation>
    <router-view></router-view>
  </b-row>
</div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-142178256-1"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-142178256-1');
</script>
<script>
const Navigation = () => import( /* webpackChunkName: 'navigation' */ '@/components/Navigation')
export default {
  name: 'app',
  components: {
    Navigation
  },
  created() {
    this.$store.dispatch('loadRecommendations')
  }
}
</script>

<style>
#app {
  font-family: "freight-sans-pro", Sans Source;
  background-color: transparent;
  background-image: url('./assets/background.jpg');
  background-size: cover;
  background-attachment: fixed;
}

#overlay {
  position: fixed;
  /* Sit on top of the page content */
  /* Hidden by default */
  width: 100%;
  /* Full width (cover the whole page) */
  height: 100%;
  /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: black;
  opacity: 0.32;
  /* Black background with opacity */
  z-index: 0;
  /* Specify a stack order in case you're using a different order for other elements */

}

#printTableau {
  z-index: 1;
}

.wrap {
  overflow: hidden;
  width: 100%;
  flex-direction: row;
}


.miuMethodology button {
  width: 98%;
}


#dashboardContainer {
  position: relative;
  width: 100%;
  padding-top: 100%;
}

#dashboardiFrame {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  border: none;
}

#methodology .fullyImplemented {
  color: #147a4c;
}

#methodology .partiallyImplemented {
  color: #ede8af;
}

#methodology .notImplemented {
  color: #e79e94;
}

#methodology .pending {
  color: #929292;
}

#methodology .fullyImplemented,
#methodology .partiallyImplemented,
#methodology .notImplemented,
#methodology .pending {
  font-weight: 600;
}

#methodology .ratings,
#methodology .row {
  padding: 0.5rem 0;
}

#methodology .ratings {
  font-weight: 500;
  margin: 0;
}

.tab-content {
  background-color: #f2f2f2;
  border-width: 2px 0px 0px 0px;
  border-color: #b5b5b5;
}

span {
  color: #3e3e3e;
}

#methodology .superior {
  color: #395a94;
}

#methodology .satisfactory {
  color: #abc094;
}

#methodology .poor {
  color: #e79e94;
}

#methodology .superior,
#methodology .satisfactory,
#methodology .poor {
  font-weight: 600;
}

#methodology .source {
  color: #a5a5a5;
}

.nav.nav-tabs {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  flex-wrap: nowrap;
}

.nav-tabs a.nav-link {
  color: #515151;
  background-color: #f2f2f2;
  border-radius: 10px 10px 0px 0px;
  border-width: 0px 1px 1px 0px;
  border-color: #d3d3d3;
  text-decoration: none;
  font-size: 0.5rem;
}

.nav-tabs .nav-link:hover {
  background-color: #e4e4e4;
}

.nav-link.active {
  color: white !important;
  background-color: #1b2c4f !important;
}

.nav-tabs {
  flex-wrap: nowrap;
  white-space: nowrap;
  max-width: 100vw;
  overflow-x: auto;
  overflow-y: hidden;
}

ul.ratings {
  padding: 0;
  overflow-x: hidden;
  list-style: none
}

ul.ratings li:before {
  float: left;
  width: 0;
  white-space: nowrap;
  content:
    "...................."
    "...................."
    "...................."
    "...................."
    "...................."
}

ul.ratings span:first-child {
  padding-right: 0.33em;
  background: white
}

ul.ratings span+span {
  float: right;
  padding-left: 0.33em;
  background: white
}

@media(min-width: 1200px) {
  .nav-tabs a.nav-link {
    font-size: 0.65rem;
  }
}

.printArrow {
  padding-right: 15px;
}

@media(max-width: 767px) {
  #printTableau {
    display: none;
  }
}

.btn-primary,
.btn-primary.disabled,
.btn-primary:disabled {
  background-color: #c5c5c5 !important;
  border: none;
  line-height: 1em;
  text-align: right;
  padding-bottom: 0.75em;
  font-size: 0.7em;
}

.btn-primary.disabled,
.btn-primary:disabled {
  opacity: 0.75;
}

.printTooltip {
  margin-right: 37px;
  margin-bottom: 5px;
}

@media (max-width:1024px) {
  .printTooltip {
    margin-right: -3px;
    margin-bottom: 5px;
  }
}

.divideBy {
  width: 88%;
  border-top: 1px solid rgba(0, 0, 0, 0.5);
  margin: auto;
}
</style>
